module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div version="'+
((__t=(VERSION))==null?'':__t)+
'" id="notice-sticky-container" class="md__sticky__commons '+
((__t=(data.noticeClass))==null?'':__t)+
'">\n  <div id="notice-sticky" class="md__sticky__content">\n    <div class="flex align-center gap-20">\n      <i id="alert-icon" class="'+
((__t=(data.icon))==null?'':__t)+
' h24 w32 f32"></i>\n      <h4 class="md__modal__title">\n        '+
((__t=(data.title))==null?'':__t)+
'\n      </h4>\n    </div>\n  </div>\n</div>';
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/sticky.html
 ** module id = 11
 ** module chunks = 0
 **/